function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M17 3.75h-3.93l1.41-1.17c.32-.27.36-.74.1-1.06a.758.758 0 00-1.06-.1l-3 2.5a.761.761 0 000 1.16l3 2.5c.14.12.31.17.48.17a.75.75 0 00.48-1.33l-1.41-1.17H17c.69 0 1.25.56 1.25 1.25V16c0 .41.34.75.75.75s.75-.34.75-.75V6.5c0-1.52-1.23-2.75-2.75-2.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 22a3 3 0 100-6 3 3 0 000 6z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M13.48 18.92l-3-2.5a.75.75 0 00-1.06.1.75.75 0 00.1 1.06l1.41 1.17H7c-.69 0-1.25-.56-1.25-1.25V8c0-.41-.34-.75-.75-.75s-.75.34-.75.75v9.5c0 1.52 1.23 2.75 2.75 2.75h3.93l-1.41 1.17c-.32.27-.36.74-.1 1.06.15.18.36.27.58.27.17 0 .34-.06.48-.17l3-2.5a.761.761 0 000-1.16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 8a3 3 0 100-6 3 3 0 000 6z"
})));